"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const Toggle = (props) => {
    const { fieldData, onChange, disableMandatory } = props;
    const { disabled } = fieldData;
    const handleChange = (event) => {
        onChange(fieldData, event.target.checked);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(material_1.FormGroup, null,
                react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Switch, { checked: !!+fieldData.value, onChange: handleChange, disabled: disabled || false, required: disableMandatory ? false : fieldData.mandatory, "data-testid": "toggle" }), label: fieldData.label }))),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(FieldValidationError, null, fieldData.errors ? (fieldData.errors.map((error) => react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error))) : (react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.Toggle = Toggle;
exports.default = exports.Toggle;
